import React from 'react';
import { motion } from 'framer-motion';
export function Bonuses() {
  const bonuses = [{
    number: '01',
    title: 'El Secreto del Relleno "Ultra-Cremoso"',
    desc: 'El secreto de las grandes confiterías para que el relleno sea suave, untuoso y que no se caiga jamás. La Base BCI que ninguna receta de YouTube te va a revelar.',
    value: '$8.000'
  }, {
    number: '02',
    title: 'Guiones de Venta "WhatsApp de Cierre"',
    desc: 'Copy-Paste listo para responder consultas, cerrar pedidos, revivir clientes y pedir testimonios. El cliente pregunta el precio y vos cerrás la venta.',
    value: '$9.000'
  }, {
    number: '03',
    title: 'Calculadora "Miga-Math" de Costos y Margen',
    desc: 'Ponés el precio de cada ingrediente y la calculadora te dice exactamente cuánto cobrar por docena. Nunca más trabajes sin saber si ganás o perdés.',
    value: '$10.000'
  }];
  return <section className="py-14 bg-brand-cream" data-id="element-16">
      <div className="max-w-6xl mx-auto px-4 md:px-8" data-id="element-17">
        <div className="text-center mb-8" data-id="element-18">
          <h2 className="text-3xl md:text-5xl font-serif font-bold text-brand-dark mb-3" data-id="element-19">
            🎁 3 BONOS ESTRATÉGICOS
          </h2>
          <p className="text-xl font-bold text-brand-gold tracking-widest uppercase" data-id="element-20">
            Siempre incluidos
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-10" data-id="element-21">
          {bonuses.map((bonus, idx) => <motion.div key={idx} className="bg-white rounded-2xl p-6 shadow-md border-t-4 border-brand-gold flex flex-col h-full" initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: idx * 0.1
        }} data-id="element-22">
              <div className="text-brand-gold font-serif text-5xl font-bold mb-3 opacity-30" data-id="element-23">
                {bonus.number}
              </div>
              <h3 className="text-xl font-bold text-brand-dark mb-3" data-id="element-24">
                🎁 BONO {idx + 1} — {bonus.title}
              </h3>
              <p className="text-brand-gray mb-5 flex-grow" data-id="element-25">{bonus.desc}</p>
              <div className="mt-auto pt-4 border-t border-gray-100 flex items-center justify-between" data-id="element-26">
                <span className="text-gray-400 line-through text-lg" data-id="element-27">
                  {bonus.value}
                </span>
                <span className="text-brand-green font-bold text-xl" data-id="element-28">
                  → GRATIS
                </span>
              </div>
            </motion.div>)}
        </div>

        <div className="bg-brand-dark text-white rounded-2xl p-6 md:p-8 text-center max-w-3xl mx-auto shadow-2xl" data-id="element-29">
          <h3 className="text-2xl md:text-3xl font-serif mb-3" data-id="element-30">
            Valor total bonos
          </h3>
          <div className="text-3xl md:text-4xl text-gray-400 line-through mb-3 font-bold" data-id="element-31">
            $27.000
          </div>
          <div className="text-4xl md:text-5xl font-bold text-brand-gold uppercase tracking-wide" data-id="element-32">
            → GRATIS con tu Miga Master Pro
          </div>
        </div>
      </div>
    </section>;
}